import { Component, OnInit } from '@angular/core';
import {CinchDataService} from "../../../common/service/cinch-data.service";

@Component({
  selector: 'app-cinch-data-test',
  templateUrl: './cinch-data-test.component.html',
  styleUrls: ['./cinch-data-test.component.scss']
})
export class CinchDataTestComponent implements OnInit {
  // Inputs forms
  auth = { uid: "", pass: "" };
  userSelected = "";
  contractSeleted = "";
  navSeleted = "";

  // Data sync variables
  users = [];
  user = {};
  contract = {};
  history = {};
  authData = {};
  navs = {};
  nav = {};

  constructor( private cinchData: CinchDataService ) {

  }

  ngOnInit() {
    // Data sync
    this.cinchData.usersData$.subscribe(x => this.users = x , e => console.log());
    this.cinchData.userData$.subscribe(x => this.user = x , e => console.log());
    this.cinchData.authUser$.subscribe(x => {this.authData = x; this.cinchData._token = x.email; this.userSelected = x.email }, e => console.log());
    this.cinchData.contractData$.subscribe(x => this.contract = x , e => console.log());
    this.cinchData.claimsData$.subscribe(x => this.history = x , e => console.log());
    this.cinchData.navs$.subscribe(x => this.navs = x , e => console.log());
    this.cinchData.nav$.subscribe(x => this.nav = x , e => console.log());

    // Events handler from service
    this.cinchData.notification$.subscribe(x => console.log("notification$", x) , e => console.log());
  }

  getAllUsers(){
    this.cinchData.fetchUsersData();
  }

  getUser(uid){
    if (uid)  this.cinchData.fetchUserData(uid);
    else this.user = {};
  }

  authUser(uid, pass ){
    if ((uid) && (pass)) this.cinchData.authUser(uid,pass);
    else {
      this.authData = {};
      this.auth ={ uid: "", pass: "" };
    }
  }

  getContract( contractId, uid){
     if (contractId) {
       this.cinchData.fetchContractData(contractId, uid);
       this.cinchData._contractID = contractId;
       this.history = {};
     }
     else {
       this.contract = {};
       this.history = {};
     }
  }

  getHistory(contractId, uid){
      if (contractId) this.cinchData.fetchClaimsData(contractId, uid);
      else {
          this.contract = {};
          this.history = {};
      }
  }
  toggleTestMode(){
        this.cinchData.toggleTestMode();
    }

  getNavs(){
    this.cinchData.fetchNavsData();
  }

  getNav(id){
    if (id) {
        this.cinchData.fetchNavData(id);
    }
  }


}
